import * as THREE from 'three';
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader';
import { WeaponType } from './weapon-type';
import { WeaponGrip } from "./weapon-grip";

export class Weapon {
    public readonly object: THREE.Object3D;
    public readonly leftGripBone: THREE.Object3D | null;
    public readonly rightGripBone: THREE.Object3D | null;
    readonly identifier = 'weapon';

    constructor(gltf: GLTF, type: WeaponType) {
        this.object = gltf.scene;
        this.object.name = type;
        this.object.type = this.identifier;
        this.object.scale.setScalar(0.01); // Convert Blender cm units to Three.js metres
        this.object.rotateZ(-Math.PI / 2); // Rotate 90° to the right on the Y axis
        this.object.rotateY(THREE.MathUtils.degToRad(22)); // Rotate 12° to the left on the X axis
        this.object.rotateX(THREE.MathUtils.degToRad(-5)); // Rotate 12° to the left on the X axis

        this.rightGripBone = this.object.getObjectByName(WeaponGrip.RightHandGrip) ?? null;
        this.leftGripBone = this.object.getObjectByName(WeaponGrip.LeftHandGrip) ?? null;

        this.alignToRightGrip();
    }

    /**
     * Offset the weapon so that the right_grip_bone sits at the local origin.
     * This way, when the weapon is parented to the character's HandIndex4Right bone,
     * the grip aligns perfectly with the hand.
     */
    private alignToRightGrip(): void {
        if (this.rightGripBone) {
            this.object.updateMatrixWorld(true);
            const gripWorldPos = this.rightGripBone.getWorldPosition(new THREE.Vector3());
            this.object.position.sub(gripWorldPos);
        } else {
            console.warn('Right grip bone not found on weapon model. Weapon may not align correctly.');
        }
    }

    public attachTo(socket: THREE.Object3D): void {
        socket.add(this.object);
    }
}
